import { Input, InputProps, InputRef } from 'antd';
import React, { Ref } from 'react';
import { styled } from 'styled-components';
import { PHONE_MASKED } from 'utils/mask';

interface InputPhoneProps extends InputProps {
  inputRef?: Ref<InputRef>;
}
const InputPhone = ({ inputRef, ...props }: InputPhoneProps) => {
  return (
    <Styled
      {...props}
      ref={inputRef}
      onKeyDown={(event: React.KeyboardEvent<HTMLInputElement>) => {
        const input = event.target as HTMLInputElement;
        input.value = PHONE_MASKED.resolve(input.value);
      }}
      maxLength={14}
    />
  );
};

export default InputPhone;

const Styled = styled(Input) <InputPhoneProps>``;
